import { getDetailTransform } from 'helpers/transformResponse';
import types from './types';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  loading: true,
  buttonLoading: false,
  loadingPagarme: true,
  pagarme: {},
  digitalAccount: {},
  digitalAccountLoading: true,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LIST_FETCHED:
      return {
        ...state,
        list: {
          content: action.payload.data.results,
          salesCount: action.payload.data.salesCount,
          total: action.payload.data.total,
          establishmentData: action.payload.data.establishmentData,
          productActions: action.payload.data.productActions,
        },
        loading: false,
      };
    case types.ITEM_DETAIL:
      return {
        ...state,
        detail: getDetailTransform(action.payload.data) || INITIAL_STATE.detail,
        loading: false,
      };
    case types.PAGARME_FETCHED:
      return {
        ...state,
        pagarme: action.payload,
        loadingPagarme: false,
      };
    case types.PAGARME_LOAD:
      return {
        ...state,
        loadingPagarme: action.payload,
      };
    case types.LIST_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case types.BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    case types.DIGITAL_ACCOUNT_FETCHED:
      return {
        ...state,
        digitalAccount: action.payload,
        digitalAccountLoading: true,
      };
    case types.DIGITAL_ACCOUNT_LOADING:
      return {
        ...state,
        digitalAccountLoading: action.payload,
      };
    default:
      return state;
  }
};
